
import {computed, defineComponent, PropType} from 'vue';
import {StoreState} from '@/models/StoreModel';
import {unescape} from 'lodash';
import {useGeolocationComposition} from "@/composables/GeolocationComposition";
import {useTranslationComposition} from "@/composables/TranslationComposition";
import {configuration} from "@/composables/ConfigurationComposition";

export default defineComponent({
  setup(props) {

    /**
     * use 'Current+Location' in case of no suggested location is selected. Using browser location also uses
     * 'Current+Location'. When a suggested location is selected, use its "formatted search" value.
     */
    const origin = computed(() => {
      if (useGeolocationComposition.formattedSearch === '' || useGeolocationComposition.formattedSearch === useTranslationComposition.browserLocationTranslation) {
        return 'Current+Location'
      }

      return encodeURIComponent(useGeolocationComposition.formattedSearch);
    });

    const isActive = computed(() => {
      const store = props.store;

      return store?.isActive
    });

    const destination = computed(() => {
      const store = props.store;

      if (store.zip !== '' && store.city !== '' && store.address !== '') {
        return encodeURIComponent(`Kik ${store.zip} ${store.city}, ${store.address}`);
      }

      return `${store.latitude},${store.longitude}`
    });

    const title = computed(() => {
      return unescape(props.store.city);
    });

    const shorttitle = computed(() => {
      return unescape(props.store.city);
    });

    const buttonlist = computed(() => {
      return configuration.buttonListTemplate(props.store, {
        origin: origin.value,
        destination: destination.value
      })
    });

    const openingWeekdays = computed(() => {
      let day = new Date().getDay() - 1;

      if (day < 0) {
        day = 6;
      }

      try {
        const times = props.store.opening_times.split('*');

        return times[day];
      } catch (e) {
        // do nothing
      }

      return '';
    });

    const openingHours = computed(() => {
      let day = new Date().getDay() - 1;

      if (day < 0) {
        day = 6;
      }

      try {
        let times = props.store.opening_times.split('*').filter((x, i) => {
          return i !== day;
        });

        for(let i = 0; i < day; i++){
          times.push(times.shift() ?? '');
        }

        return times.join('<br/>');
      } catch (e) {
        // do nothing
      }

      return '';
    });

    return {
      translationComposition: useTranslationComposition,
      geolocationComposition: useGeolocationComposition,
      configuration: configuration,
      openingWeekdays,
      openingHours,
      buttonlist,
      title,
      shorttitle,
      destination,
      origin,
      isActive,
    };
  },
  props: {
    store: {
      type: Object as PropType<StoreState>,
      default: () => null
    }
  },
  data(){
    return {
      isCollapsedOpenings: true
    }
  },
  watch: {
    isActive(n, o) {
      if (n === false && o === true) {
        this.close();
      } else if (n === true && o === false) {
        this.open();
      }
    }
  },
  methods: {
    /**
     * open when store is active
     */
    open() {
      this.$emit('open', this.$el);
    },
    /**
     * close when store is inactive
     */
    close() {
      this.$emit('close', this.$el);
    },
    toggle() {
      if (this.isActive) {
        this.$emit('deactivate', {
          store: this.store
        });
      } else {
        this.$emit('activate', {
          store: this.store
        });
      }
    },
    toggleOpenings() {
      this.isCollapsedOpenings = !this.isCollapsedOpenings;
    }
  }
});
